export default __webpack_public_path__ + "static/media/consulting-icon.97faa892.png";